module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Update Password"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8-tablet is-6-desktop is-offset-3-desktop is-offset-2-tablet is-one-third-fullhd is-offset-one-third-fullhd"
  }, [_c('section', {
    staticClass: "mt-4"
  }, [(_vm.setPassword) ? [_c('h1', {
    staticClass: "title is-2 mb-2"
  }, [_vm._v("Set Password")]), _vm._v(" "), (_vm.setPassword) ? _c('p', {
    staticClass: "title fs-6 mb-2 text-muted"
  }, [_vm._v("Create a password to enable email and password.")]) : _vm._e()] : _c('h1', {
    staticClass: "title is-2 mb-2"
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.change()
      }
    }
  }, [(!_vm.setPassword) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Current Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "input",
    class: _vm.errorOld && 'is-danger',
    attrs: {
      "type": "password",
      "placeholder": "old password"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), (_vm.errors.old) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Incorrect password")]) : _vm._e(), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    staticClass: "input",
    class: _vm.errorNewPasswords && 'is-danger',
    attrs: {
      "type": "password",
      "placeholder": "new password"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  })]), (_vm.errors.notMatching) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Doesn't match")]) : _vm._e(), _vm._v(" "), (_vm.errors.common) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Too Common")]) : _vm._e(), _vm._v(" "), (_vm.errors.short) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Too Short")]) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Password (Again)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    staticClass: "input",
    class: _vm.errorNewPasswords && 'is-danger',
    attrs: {
      "type": "password",
      "placeholder": "new password"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  })]), (_vm.errors.notMatching) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Doesn't match")]) : _vm._e(), _vm._v(" "), (_vm.errors.common) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Too Common")]) : _vm._e(), _vm._v(" "), (_vm.errors.short) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Too Short")]) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('section', {
    staticClass: "d-flex justify-content-between flex-align-center"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    attrs: {
      "disabled": !_vm.valid,
      "type": "submit"
    }
  }, [_vm._v("Update")])])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3bcf21ad"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = 1009
// module chunks = 0